import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AppContextProvider } from "./AppContext";
import "./pages/basic.css";
import Intro from "pages/intro";
import Form from "pages/form";
import Page from "layout/page";
import { LayoutContextProvider } from "layout/layout-provider";
import Result from "pages/result";
import Pausepage from "./pages/pausescreen/pausepage";
import { FormContextProvider } from "contexts/form/form-provider";
import { ScribeContextProvider } from "contexts/scribe/scribe-provider";
import IdleScreen from "./pages/pausescreen/idlescreen";

const InternalApp: React.FC = () => {
  const location = useLocation();

  let isExternalLinksDisabled =
    localStorage.getItem("external_links_disabled") ?? "false";

  if (isExternalLinksDisabled === "false") {
    const queryParams = new URLSearchParams(location.search);
    const externalLinksParam = queryParams.get("external_links_disabled");
    isExternalLinksDisabled = externalLinksParam ?? "false";
  }

  if (isExternalLinksDisabled === "true") {
    localStorage.setItem("external_links_disabled", isExternalLinksDisabled);
  }

  return (
    <ScribeContextProvider>
      <FormContextProvider>
        <div className="App">
          <Page>
            <Pausepage></Pausepage>
            <IdleScreen></IdleScreen>
            <Routes>
              <Route path="/result/:name" element={<Result />} />
              <Route path="/result" element={<Navigate to={"/"} />} />
              <Route path="/home" element={<Form />} />
              <Route path="/" element={<Intro />} />
            </Routes>
          </Page>
        </div>
      </FormContextProvider>
    </ScribeContextProvider>
  );
};

const App: React.FC = () => (
  <AppContextProvider>
    <LayoutContextProvider>
      <Router>
        <InternalApp />
      </Router>
    </LayoutContextProvider>
  </AppContextProvider>
);

export default App;
